import React from 'react';
import { Box, Button, Container, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useConsent } from '../analytics/ConsentContext';
import { azureColors } from '../theme';

const CookiePolicyPage = () => {
  const { consent, resetConsent, acceptAnalytics, rejectAnalytics } = useConsent();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#F3F2F1' }}>
      <Header />
      <Container sx={{ flex: 1, py: 4, maxWidth: '860px' }}>
        <Typography variant="h3" gutterBottom sx={{ color: azureColors.primary }}>
          Cookie Policy
        </Typography>
        <Typography variant="body2" sx={{ color: azureColors.textSecondary, mb: 3 }}>
          Last updated: 24 July 2026
        </Typography>

        <Typography variant="h5" gutterBottom>What we use</Typography>
        <Typography variant="body1" paragraph>
          This site primarily uses <strong>localStorage / sessionStorage</strong> (similar to cookies) rather than
          classic HTTP cookies:
        </Typography>
        <Typography component="ul" variant="body1" sx={{ pl: 3, mb: 2 }}>
          <li>
            <strong>portfolio_consent_v1</strong> (necessary) — stores whether you accepted or rejected analytics
          </li>
          <li>
            <strong>portfolio_visitor_id</strong> (analytics) — anonymous visitor id, only used if analytics accepted
          </li>
          <li>
            <strong>portfolio_session_id</strong> (analytics) — session id for grouping page views in one browse session
          </li>
        </Typography>

        <Typography variant="h5" gutterBottom>Your current choice</Typography>
        <Typography variant="body1" paragraph>
          {consent
            ? `Analytics is currently ${consent.analytics ? 'accepted' : 'rejected'} (version ${consent.version}).`
            : 'You have not made a choice yet — the consent banner will appear until you decide.'}
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 4 }}>
          <Button variant="contained" onClick={acceptAnalytics}>Accept analytics</Button>
          <Button variant="outlined" onClick={rejectAnalytics}>Reject analytics</Button>
          <Button variant="text" onClick={resetConsent}>Reset choice</Button>
        </Box>

        <Typography variant="body1" paragraph>
          More detail: <Link component={RouterLink} to="/privacy">Privacy Policy</Link>.
        </Typography>
      </Container>
      <Footer />
    </Box>
  );
};

export default CookiePolicyPage;
